export const environment = {
  production: false,
  APP_URL: 'https://test.ips.billionbroadcaster.com/',
  API_URL: 'https://test.ims.billionbroadcaster.com/api',
  GOOGLE_MAP_KEY: 'AIzaSyCugyOGp0tiTpyM67lhXCEJjTE-eKcAfJc',
  GOOGLE_MAP_ID: '677c40edbec7e81616a81fb6',
  GOOGLE_MAP_DEMO_ID: 'DEMO_MAP_ID',
  CLOUD_FRONT: 'https://dfeljlgwjhrm9.cloudfront.net/',
  API_APP_URL: 'https://test.ims.billionbroadcaster.com/api/app',

};
